export default class DateGroupingHelper {
  static getSortedEntriesByProperty(entries, propName, descending = true) {
    return entries.sort((left, right) => {
      if (descending) {
        return right[propName]-left[propName];
      }

      return left[propName]-right[propName];
    });
  }

  static sortGroupEntriesByProperty(entryGroups, propName, descending = true) {
    entryGroups.forEach((entryGroup) => {
      entryGroup.entries = DateGroupingHelper.getSortedEntriesByProperty(entryGroup.entries, propName, descending);
    });
  }
}
